@use '@fukuri-admins/ui/layout' as *;

// Figmaスタイル: 高さ40px、background/secondary、ボーダー半径lg
.row {
  display: flex;
  align-items: center;
  gap: spacing('16');

  width: 100%;
  height: 40px;
  box-sizing: border-box;

  padding: spacing('4') spacing('8');

  background-color: background('Secondary');
  border: 1px solid border('Secondary');
  border-radius: borderRadius('lg');
}

.fileInfo {
  display: flex;
  align-items: center;
  gap: spacing('8');
  flex: 1;
  min-width: 0;
  overflow: hidden;
}

.icon {
  flex-shrink: 0;
  color: text('High');
}

// ファイル名: 12px, text/high、省略表示
.name {
  @include typography('Jp/12_W3');
  color: text('High');
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
}

// ファイルサイズ: 12px, text/low (#6c6c79)
.size {
  @include typography('Jp/12_W3');
  color: text('Low');
  flex-shrink: 0;
}
